export default "__VITE_PUBLIC_ASSET__b447419b__"